
<div>
  <EntityShowHeader :entity="entity"/>
  <DataPage
    ref="entityProductsList"
    :columns="columns"
    :fetch-callback="fetchEntityProducts"
    :model="EntityProductModel"
    :header-underline="false"
    has-row-actions
  >
    <template #level>
      <Badge variant="soft-primary">
        {{ __('badges.parent') }}
      </Badge>
    </template>

    <template #afterItem="{ item }">
      <tr v-for="(child, key) in item.children" :key="`${key}_${Math.random()}`" class="row-tight">
        <td>
          <Icon icon="corner-down-right" size="12"/>
          {{ child.name }}
        </td>
        <td>
          <Badge variant="soft-secondary">
            {{ __('badges.child') }}
          </Badge>
        </td>
        <td>
          {{ child.tag }}
        </td>
        <td>
          {{ child.commission }}
        </td>
        <td>
          {{ child.grossAmount }}
        </td>
        <td>
          {{ child.feeAmount }}
        </td>
        <td v-if="isEntityProductHistoryEnabled">
          {{ child.activeFrom }}
        </td>
        <td>
          <ActionPopover :id="child.id" v-can-any="[ 'products.update', 'entity-products.unlink' ]">
            <b-button
              v-can:products.update
              class="dropdown-item"
              size="sm"
              @click="editLinkedProduct(child)"
            >
              <Icon icon="edit" class="mr-2" size="14"/>
              {{ __('buttons.edit') }}
            </b-button>
          </ActionPopover>
        </td>
      </tr>
    </template>

    <template #tableHeaderActions>
      <b-button
        v-can:products.create
        variant="primary"
        size="sm"
        data-testid="link-product-btn"
        @click="openLinkProductModal"
      >
        <Icon icon="plus-circle" size="14" class="mr-2"/>
        {{ __('entities.link-product') }}
      </b-button>
    </template>

    <template #actionButtons="{ item }">
      <ActionPopover :id="item.id" v-can-any="[ 'products.update', 'entity-products.unlink' ]">
        <b-button
          v-can:products.update
          class="dropdown-item"
          size="sm"
          @click="isEntityProductHistoryEnabled ? openProductHistory(item) : editLinkedProduct(item)"
        >
          <Icon icon="edit" class="mr-2" size="14"/>
          {{ __('buttons.edit') }}
        </b-button>
        <b-button
          v-can:products.update
          class="dropdown-item"
          size="sm"
          @click="unlink(item)"
        >
          <Icon icon="edit" class="mr-2" size="14"/>
          {{ __('entities.button-unlink') }}
        </b-button>
      </ActionPopover>
    </template>
  </DataPage>
</div>
